import attribute from "./attribute";

import Tree from "./tree.js"; 
import Dirt from "./dirt.js";  
import Cloud from "./cloud.js";  

const createMultipleRandomArray = function(opts) {
    const defs = {
        max: 1,
        total: 10,
        keyPrefix: '',
    }
    const sets = Object.assign(defs, opts);

    let result = [];

    // Create a random array of objects
    for (let i = 1; i <= sets.total; i++) {
        var key = sets.keyPrefix + '-' + Phaser.Math.Between(1, sets.max);

        // Re-generate key if its previous key is the same
        if (i > 1 && sets.max > 1) {
            while (key === result[i - 2]) {
                key = sets.keyPrefix + '-' + Phaser.Math.Between(1, sets.max);
            }
        }

        result.push(key);
    }

    return result;
}

const multipleGenerator = function(opts) { 
    const defs = {
        max: 1,
        total: 10,
        scene: null, 
        initX: 0,
        initY: 0,
        keyPrefix: '',
        space: 0,
        speed: 5
    }
    const sets = Object.assign(defs, opts);

    // console.log(sets);

    if (!sets.scene) {
        throw new Error('Object, scene is required');
    }

    let result = [];
    var objGroupWidth = sets.initX;

    // Create a random array of objects
    const randomKeys = createMultipleRandomArray({
        max: sets.max,
        total: sets.total,
        keyPrefix: sets.keyPrefix
    });

    // Map length of randomKeys
    var mapLength = 0;
    for (let i = 0; i < randomKeys.length; i++) {
        const key = randomKeys[i];
        mapLength += attribute[key].width;
        mapLength += sets.space;
    }
    
    for (let i = 0; i < randomKeys.length; i++) {
        const key = randomKeys[i];
        const objOptions = {
            scene: sets.scene,
            x: objGroupWidth,
            y: sets.initY,
            mapLength: mapLength,
            key: key,
            speed: sets.speed
        }
        switch (sets.keyPrefix) {
            case 'tree':
                result.push(new Tree(objOptions));
                break;
            case 'dirt':
                result.push(new Dirt(objOptions));
                break;
            case 'cloud':
                result.push(new Cloud(objOptions));
                break;
            default:
                break;
        }
        objGroupWidth += result[i].width + sets.space;
    }

    // console.log(result);
    
    return result;

}

export default multipleGenerator;